import * as React from 'react'
import type { CommonDeps } from '../base/CommonDeps'
import ErrorBoundary from '../error/ErrorBoundary'
import { usePromiseManager } from './PromiseManager'

interface Props<T> {
    deps: CommonDeps
    cacheKey: string
    fetch: () => Promise<T>
    render: (t: T) => React.ReactElement<unknown>
}

export function renderPromise<T>(deps: CommonDeps, key: string, fetch: Props<T>['fetch'], render: Props<T>['render']) {
    return (
        <ErrorBoundary deps={deps}>
            <PromiseRenderer deps={deps} cacheKey={key} fetch={fetch} render={render} />
        </ErrorBoundary>
    )
}

export function PromiseRenderer<T>({ deps, cacheKey, fetch, render }: Props<T>) {
    const promiseManager = usePromiseManager(deps)

    React.useEffect(() => {
        promiseManager.trigger(fetch)
    }, [cacheKey])

    return promiseManager.render(render)
}
